import { Button, Col, Form, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import { cloneDeep, isEmpty } from 'lodash';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormInputDate, FormSelect, FormTextInput } from '../../../../../../shared/components/crmFormElement/FormInput';
import {
  BF_VALIDATION_REGEX,
  GROUP_POLICY_HDFC,
  GUTTOR_SPACE, ONLY_NUMBER_REGEX, VALIDATE_MESSAGES,
} from '../../../../../../shared/constants/commonConstants';
import {
  BENEF_CONSTANTS, BENEFICIARY_SEARCH_OPTION, BENEFICIARY_SEARCH_OPTION_ABHI, BENEFICIARY_SEARCH_OPTION_MDI,
  BENEFICIARY_SEARCH_OPTION_SHAI, CORPRATE_NAME_REGEX,
  DEFAULT_ADMISSION_FORM_VALUE, EMPLOYEE_ID_REGEX,
  formInputStates, GOVT_SCHEME_SEARCH_OPTION,
  PATIENT_NAME_MAX_CHAR_LIMIT, BENEF_NOT_FOUND_MESSAGE, MDI_MEMBERID_PREFIX, POLICY_TYPE_OPTIONS, BENEFICIARY_SEARCH_WITH_ONLY_MEMBERID,
  MDI_RETAIL_POLICY_ERROR_MESSAGE, BENEF_RETRY_MESSAGE, PATIENT_NAME_MIN_CHAR_LIMIT,
} from '../../../../../../shared/constants/crmConstants';
import { RootState } from '../../../../../../store';
import * as actions from '../../../../../../store/actions/newAdmissionAction';
import { NHCXState } from '../../../../../../store/models/nhcxModel';
import { centeredNotification, formatName, isNonIntegratedPayer } from '../../../../../../utils/utility';
import {
  abhiValidation, customGTMEvent, filterBeneficiaries, getIHave, getMessageForDisplay, getPolicyCheck, getPolicyGroup,
  otherPolicyValidation, policyValidation, policyWarning, updateInputStates,
} from '../../../service/crmUtils';
import { NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';
import {
  setBeneficiarySearchResponsePayerId, setHyphenGroup, setMemberName, setSelectedTab,
  setShowPayerNotConfiguredMessage, setShowPayerUpdatedMessage, setAllowNextStage, setStarDisabledBenefMessage,
} from '../../../../../../store/actions/newAdmissionAction';
import ApplicationDetail from '../../../../../../shared/services/applicationDetail.service';
import { ReactComponent as SearchIcon } from '../../../../../../assets/images/svg/Search_Icon.svg';
import { ReactComponent as DownArrow } from '../../../../../../assets/images/svg/DownArrow.svg';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../../../../config/formControlConfig';
import { startOfDay, isBefore } from 'date-fns';

const BeneficiarySearchPanelRedesign = (props: any): ReactElement => {
  const { isLoading, completeStep, resetSteps, admissionForm } = props;
  const [benefForm] = Form.useForm();
  const [selectedBenefSearch, setSelectedBenefSearch] = useState('');
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [currentGrp, setCurrentGrp] = useState('');
  const [policyWarn, setPolicyWarn] = useState<boolean>(true);
  const [policyCheck, setPolicyCheck] = useState<boolean>(false);
  const [memberIdCheck, setMemberIdCheck] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(false);
  const [count, setCount] = useState(0);
  const [showRetryMessage, setShowRetryMessage] = useState(false);
  const [displayMessage, setRetryDisplayMessage] = useState(<></>);
  const [prevSelectedBenefSearch, setPrevSelectedBenefSearch] = useState('');
  const [searchOptionCounts, setSearchOptionCounts] = useState<Record<string, number>>({});
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [ClaimCreationWithoutBenef, setClaimCreationWithoutBenef] = useState<boolean>(false);
  const [policyTypeValue, setIsPolicyTypeSelected] = useState<string>('');

  const { payer: {
    isClaimCreationBlockedWithoutBenef,
    isGovtScheme, name: payerName, value: payerValue, shortName, isRpaPayer, isOnMailPayer },
    payer, allPayers,
   } = useSelector((state: RootState): any => state.payerList);
  const payerFormConfiguration = CONTROL_CONFIG_BASED_ON_PAYER[payerName];
  const payerConfigValues = Object.values(payerFormConfiguration || '');
  const isContractedProvider = ApplicationDetail.instance.getIsContractedHospital();

  const combiPolicyExist = payerConfigValues?.some((config: any): any => Boolean(config?.combiPolicyExist));
  const isPolicyWarningEnabled = payerConfigValues?.filter(({ type, hidden }: any): boolean => type === 'ABHI_POLICY_WARNING'
    && !hidden).length > 0;
  const isPolicyGroupEnabled = payerConfigValues?.filter(({ type, hidden }: any): boolean => type === 'ABHI_POLICY_GROUP'
    && !hidden).length > 0;
  const isOptionalBenefFields = payerConfigValues?.some(
    ({ type, hidden }: any): boolean => type === 'BENEF_OPTIONAL_CRITERIA' && !hidden);
  const isEmployeeIdOptional = payerConfigValues?.some(
    ({ type, hidden }: any): boolean => type === 'isOptionalForPolicyNo' && !hidden);
  const isPolicyNoReqForEmpId = (payerConfigValues?.some(({ type, hidden }: any): boolean =>
    (type === 'isReqForEmpId' && !hidden))) || false;
  const isShowProductName = payerConfigValues?.some((config: any): any => Boolean(config?.showProductName));
  const showStarBenefFields = (shortName === 'SHAI' && !isNonIntegratedPayer(isOnMailPayer, isRpaPayer) || isShowProductName);
  const dateOfBirthRequired = (payerConfigValues?.some(({ type, hidden }: any): boolean =>
    (type === 'DOB_REQUIRED_FOR_BENEF' && hidden))) || false;
  const todayDate = startOfDay(new Date());
  const enableSubmissionForContracted = payerConfigValues?.some((config: any): boolean => (config?.allowSubmissionForContracted))
  && isContractedProvider;
  const isManipalPayer: boolean = payerConfigValues?.some((config: any): boolean => Boolean(config?.isManipalClaim)) ?? false;
  const isOnlyMemberIdBenefField = payerConfigValues?.some(({ type, hidden }: any):
    boolean => type === 'ONLY_MEMBER_ID_BENEF_FIELD' && !hidden);
  const isVoloIPPPayer: boolean = payerConfigValues?.some((config: any): boolean => Boolean(config?.isVoloIPPClaim)) ?? false;
  const inMinCharacterValidationRequired = Boolean(payerConfigValues?.filter(({type, hidden}: any): boolean =>
    type === 'MIN_CHARACTER_VALIDATION' && !hidden).length);

  const onSearchChange = (value: any): void => {
    dispatch(setHyphenGroup(false));
    dispatch(setShowPayerNotConfiguredMessage(false));
    setSelectedBenefSearch(value);
    dispatch(actions.getSelectedSearchType(value));
    setShowRetryMessage(false);
    setRetryDisplayMessage(<></>);
    resetSteps(['memberSearch', 'memberOrPolicy', 'memberCard']);
    if (isOptionalBenefFields) {
      benefForm.resetFields(['memberId']);
    }
  };
  const { selectedPatientDetail, isAutomatedNewAdmission } = useSelector((state: RootState): any => state.hospital);
  const commonDetails = { loading, form: benefForm, isLoading };
  const { selectedPolicyDetail, memberName } = useSelector((state: RootState): NHCXState => state.nhcx);
  const { beneficiarySearchResponsePayerId, hyphenatedBasedGroupPolicy, memberSearchRequest }: any =
    useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const [benefSearchFields, setBenefSearchFields] = useState<any[]>([]);
  const appDetail = ApplicationDetail.instance;
  const isHisSearchEnabled = appDetail?.getIsHISSearchEnabled();
  const [inputStates, setInputStates] = useState(formInputStates.IPPRedesignBenefForm);

  const onClickSearch = (formVal: any): void => {
    validateFields();
    setPrevSelectedBenefSearch(selectedBenefSearch);
    dispatch(actions.setSelectedCardIndex(-1));
    if (isEmpty(selectedPolicyDetail)) {
      resetSteps(['memberSearch', 'memberOrPolicy', 'documentsAttached', 'claimReviewed', 'memberCard']);
    } else if (!isEmpty(selectedPolicyDetail)) {
      resetSteps(['memberSearch', 'documentsAttached', 'claimReviewed', 'memberCard']);
    }

    customGTMEvent({
      event: 'WA_BENEFC_SEARCH',
    });
    initiateMemberForm();

    const formattedMemberId = (isOptionalBenefFields && selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_MDI[0]) ? `${MDI_MEMBERID_PREFIX}${formVal.memberId}` : formVal?.memberId;
    const newAdminssionSearchVal = {
      ...formVal,
      fullName: formVal?.patientName || '',
      payer: payerName,
      memberId: formattedMemberId,
    };
    const updatedFormValues = {
      ...formVal,
      memberId: formattedMemberId,
    };
    updateInputStates(newAdminssionSearchVal, setInputStates, '.his-search-row-cont input', { resetFocus: true, blurDomInputs: true });

    if (Object.keys(formVal).length) {
      setLoading(true);
      setCount(count + 1);
      dispatch(actions.setNewAdminssionSearchVal(newAdminssionSearchVal));
      if (isHisSearchEnabled && newAdminssionSearchVal?.fullName) {
        dispatch(setMemberName(newAdminssionSearchVal?.fullName));
      }
      dispatch(actions.benefSearch(updatedFormValues, updateBeneficiaryList, failedBeneficiarySearch));
    }
  };

  const initiateMemberForm = (): void => {
    admissionForm.resetFields();
    dispatch(actions.sethospDetailsForRoomType({}));
    dispatch(actions.setBeneficiaryList([]));
    dispatch(actions.setIsShowAdmissionForm(false));
    dispatch(actions.setShowBeneficiaryCard(true));
    dispatch(actions.setSelectedBeneficiary(null));
    dispatch(actions.setAdmissionForm(cloneDeep(DEFAULT_ADMISSION_FORM_VALUE)));
    dispatch(setSelectedTab(0));
    dispatch(actions.setUploadedFiles([]));
    dispatch(actions.setIsAbhaVerified(false, {}));
    dispatch(setShowPayerNotConfiguredMessage(false));
    dispatch(setShowPayerUpdatedMessage(false));
    dispatch(setAllowNextStage(true));
    dispatch(setStarDisabledBenefMessage(''));
    dispatch(actions.setHospitalOtherRoomType(''));
  };

  useEffect((): any => {
    const showClaimFormWithoutBenef = Object.values(searchOptionCounts).some((value: number): boolean => value > 1);
    setClaimCreationWithoutBenef(showClaimFormWithoutBenef);
    if (showClaimFormWithoutBenef) {
      if (!isClaimCreationBlockedWithoutBenef || enableSubmissionForContracted) {
        handleManualSubmissionFlow();
      }
    }
  }, [searchOptionCounts]);

  useEffect((): any => {
    setShowRetryMessage(false);
    setCount(0);
    setBenefSearchFields(getSearchOption());
    setIsPolicyTypeSelected('');
  }, [payerName]);

  useEffect((): void => {
    setRetryDisplayMessage(getMessageForDisplay(prevSelectedBenefSearch, isOptionalBenefFields, benefForm));
  }, [count]);

  useEffect((): void => {
    const defaultValue = benefSearchFields?.[0];
    benefForm.setFieldsValue({ iHave: defaultValue });
    dispatch(setShowPayerNotConfiguredMessage(false));
    setSelectedBenefSearch(defaultValue);
    dispatch(actions.getSelectedSearchType(defaultValue));
    setShowRetryMessage(false);
  }, [benefSearchFields, payerName]);

  useEffect((): void => {
    if (beneficiarySearchResponsePayerId === 0) {
      benefForm.setFieldsValue({
        Payer: payerValue,
        policyNumber: '',
        corporateName: '',
        memberId: '',
        patientName: '',
        employeeId: '',
      });
      setCurrentGrp('');
    }
  }, [payerName]);

  const validateFields = (): any => {
    setTimeout((): any => {
      benefForm
        ?.validateFields()
        .then((): any => {
          setDisable(true);
        })
        .catch((error: any): any => {
          const { errorFields } = error;
          if (errorFields?.length > 0) {
            setDisable(false);
          }
        });
    }, 200);
  };

  const onChangePolicyType = (): void => {
    const { policyType } = benefForm?.getFieldsValue(['policyType']);
    if (policyType) {
      setIsPolicyTypeSelected(policyType);
    }
  };
  useEffect((): void => {
    if (isAutomatedNewAdmission && !isEmpty(memberSearchRequest)) {
      const iHave = getIHave(memberSearchRequest, benefSearchFields);
      onSearchChange(iHave);
      const patientName = formatName(memberSearchRequest?.memberName);

      benefForm?.setFieldsValue({
        ...memberSearchRequest,
        iHave,
        patientName,
      });
      updateInputStates(memberSearchRequest, setInputStates);
      completeBenefSearchStep();
      return;
    }
    if (!isEmpty(selectedPatientDetail)) {
      const patientDetails = selectedPatientDetail?.patientDetails || selectedPatientDetail;
      const patientName = formatName(selectedPatientDetail?.memberName || selectedPatientDetail?.patientDetails?.patientName);

      benefForm?.setFieldsValue({
        ...patientDetails,
        patientName,
      });

      updateInputStates({
        ...patientDetails,
        patientName,
      }, setInputStates );
    }

    if (!isEmpty(selectedPolicyDetail)) {
      const policyFields = {
        memberId: selectedPolicyDetail?.memberId,
        patientName: memberName,
        policyNumber: selectedPolicyDetail?.policyNo || selectedPolicyDetail?.productId,
      };

      benefForm?.setFieldsValue(policyFields);
      updateInputStates(policyFields, setInputStates);
    }
  }, [selectedPatientDetail, selectedPolicyDetail, payer, memberSearchRequest]);

  const completeBenefSearchStep = (): void => {
    const stepName = !isEmpty(selectedPolicyDetail)
      ? 'memberSearch'
      : !isEmpty(selectedPatientDetail)
      ? 'memberOrPolicy'
      : 'memberSearch';

    completeStep(stepName);
  };

  const updateBeneficiaryList = (benefList: any[]): void => {
    setShowRetryMessage(false);
    setLoading(false);
    if (beneficiarySearchResponsePayerId > 0) {
      const finalPayer = allPayers.find((p: any): any => (p.id === beneficiarySearchResponsePayerId && p.isGovtScheme === false));
      if (!finalPayer) {
        dispatch(setBeneficiarySearchResponsePayerId(0));
        return;
      }
    }
    completeBenefSearchStep();

    const finalList = filterBeneficiaries(isOptionalBenefFields, selectedBenefSearch, benefList, failedBeneficiarySearch);

    dispatch(actions.setBeneficiaryList(finalList));
  };

  const failedBeneficiarySearch = (errorMsg: string, allowNextStage: any, retryMessage: any): void => {
    setErrorMessage(errorMsg);
    setSearchOptionCounts((prev: Record<string, number>): Record<string, number> => {
      const currentCount = prev[selectedBenefSearch] || 0;
      return {
        ...prev,
        [selectedBenefSearch]: currentCount + 1,
      };
    });
    setShowRetryMessage(false);
    let enableManual = false;
    setLoading(false);
    customGTMEvent({
      event: `Beneficiary search failure for ${payer.shortName}`,
      payer: payer.name,
    });
    if (retryMessage !== 'Bad Gateway') { // incase of beneficiary search timeout
      setShowRetryMessage(retryMessage);
    }
    if (isOptionalBenefFields && policyTypeValue === POLICY_TYPE_OPTIONS.SECTOR_TYPES[0] &&
      errorMsg.includes(MDI_RETAIL_POLICY_ERROR_MESSAGE)) {
      setRetryDisplayMessage(BENEF_RETRY_MESSAGE.MDI_CORPORATE_SEARCH_INFO);
    }
    // the below check is to disable form submission if the 'isClaimCreationBlocked' flag is true [IPP-3655] and
    // allow submission for HDFC only after 1 retry [IPP-4370]
    if (!(isClaimCreationBlockedWithoutBenef) || enableSubmissionForContracted) {
      // if claim creation is not blocked and it's a non-HDFC payer
      if (!retryMessage) {
        // Set enableManual to true only if allowNextStage is not 'NO' and count is 1 or less
        enableManual = String(allowNextStage)?.toUpperCase() !== 'NO' && count <= 1;
      }

      // Explicitly set enableManual to false if count is more than 1 and allowNextStage is 'NO'
      if (count >= 1 && String(allowNextStage)?.toUpperCase() === 'NO') {
        enableManual = false;
      }
      if (enableManual) {
        handleManualSubmissionFlow();
      }
    } else {
      centeredNotification(errorMsg);
    }
  };

  const handleManualSubmissionFlow = (): void => {
    centeredNotification(enableSubmissionForContracted ? BENEF_NOT_FOUND_MESSAGE : errorMessage);
    completeStep('memberOrPolicy');
    completeStep('memberSearch');
    completeStep('memberCard');
    dispatch(actions.enableManualSubmission());
    enableAdmissionForm();
  };

  const enableAdmissionForm = (): void => {
    dispatch(actions.setIsShowAdmissionForm(true));
    dispatch(actions.setSelectedBeneficiary(null));
  };

  const memberIDvalidation = (event: any): any => {
    const memberId = event?.target?.value;
    setMemberIdCheck(false);
    if (shortName === 'ABHI' && BF_VALIDATION_REGEX.test(String(memberId)?.toUpperCase())) {
      setMemberIdCheck(true);
    }
  };

  const getPolicyGrouping = (event: any): any => {
    if (isPolicyWarningEnabled) {
      setPolicyWarn(policyWarning(event?.target?.value));
      setPolicyCheck(getPolicyCheck(event?.target?.value));
    } {
      if (isPolicyGroupEnabled) {
        setCurrentGrp(getPolicyGroup(event?.target?.value, shortName));
      }
    }
  };

  const policyNoSpaceCheck = (e: any): any => {
    if (shortName === 'HDFC') {
      e.target.value = e.target.value.trim().replace(/\s+/g, '');
    }
  };

  const handleUserFocus = (key: string): void => {
    setInputStates((prevState: any): any => ({
      ...prevState,
      [key]: {
        isFocused: true,
        hasValue: !!benefForm?.getFieldValue(key),
      },
    }));
  };

  const handleUserUnFocus = (key: string, e: React.FocusEvent<HTMLInputElement>): void => {
    const value = e?.target?.value;
    setInputStates((prevState: any): any => ({
      ...prevState,
      [key]: {
        isFocused: false,
        hasValue: !!value,
      },
    }));
  };

  const resetBenefSearch = (): void => {
    if ( isAutomatedNewAdmission ) {
      return;
    }
    const stepsToReset = [
      'memberSearch',
      ...(isEmpty(selectedPolicyDetail) ? ['memberOrPolicy'] : []),
      'documentsAttached',
      'claimReviewed',
      'memberCard',
    ];
    resetSteps(stepsToReset);
    initiateMemberForm();
  };

  const getSearchOption = (): any[] => {
    // added shortname and removed employee id for abhi
    return isGovtScheme ? GOVT_SCHEME_SEARCH_OPTION[payerName] : (isOnlyMemberIdBenefField || isVoloIPPPayer)
      ? BENEFICIARY_SEARCH_WITH_ONLY_MEMBERID : (shortName === 'ABHI' || isManipalPayer) ?
      BENEFICIARY_SEARCH_OPTION_ABHI : (shortName === 'MD India') ? BENEFICIARY_SEARCH_OPTION_MDI :
        showStarBenefFields ? BENEFICIARY_SEARCH_OPTION_SHAI : BENEFICIARY_SEARCH_OPTION;
  };

  const renderStarBenefFields = (): any => {
    return (
      (showStarBenefFields) &&
      <Row gutter={GUTTOR_SPACE} className="his-search-row-cont" style={{ marginLeft: '-22px' }}>
        {selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_SHAI[1] &&
          <Col md={10} className="icici-search-options star-search-field pdr-0">
            <FormTextInput detail={{
              ...commonDetails,
              key: 'corporateName',
              isLoading,
              regex: CORPRATE_NAME_REGEX,
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('corporateName'),
              onBlur: (e: any): any => handleUserUnFocus('corporateName', e),
              floatLabel: inputStates?.corporateName?.isFocused || inputStates?.corporateName?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.corporateName?.isFocused ? '' : 'Enter Corporate Name',
              searchType: 'search-option-3',
              fieldInFocus: inputStates?.corporateName?.isFocused,
              required: true,
              disabled: loading,
            }} />
          </Col>
        }

        {selectedBenefSearch !== BENEFICIARY_SEARCH_OPTION_SHAI[2] &&
          <Col md={selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_SHAI[1] ? 12 : 17}
            className={`icici-search-options star-search-field
              ${selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_SHAI[1] ? 'pdl-0' : 'star-pd'}`}>
            <FormTextInput
              detail={{
                ...commonDetails,
                key: 'patientName',
                label: 'Patient Name',
                isLoading,
                isName: true,
                smallFloatLabel: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                  rules: [
                    { max: 50, message: PATIENT_NAME_MAX_CHAR_LIMIT },
                    ...(inMinCharacterValidationRequired ? [{ min: 4, message: PATIENT_NAME_MIN_CHAR_LIMIT }] : [])],
                isMaxLengthNotApplicable: true,
                className: 'HISSearchUI',
                onFocus: (): any => handleUserFocus('patientName'),
                onBlur: (e: any): any => handleUserUnFocus('patientName', e),
                floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName?.hasValue,
                hideLabel: true,
                searchType: selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_SHAI[0] ? 'search-option-3' : '',
                placeholder: inputStates?.patientName?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
                smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                fieldInFocus: inputStates?.patientName?.isFocused,
                required: !isOptionalBenefFields,
                disabled: loading,
              }} />
          </Col>
        }
        {selectedBenefSearch !== BENEFICIARY_SEARCH_OPTION_SHAI[2] && <Col md={2} className="ICICI-Search">
          <Button
            data-testid="beneficiary-search-button"
            type={!disable ? undefined : 'primary'}
            style={{ width: 120, height: 36 }}
            htmlType="submit"
            loading={loading}
            className={`NA-his-next-button NA-top-2
                    ${(isOptionalBenefFields && !disable) ? 'benef-submit-disabled' : 'benef-submit-btn'}
                  `}
            icon={<SearchIcon className="his-benef-search-icon" />}
            disabled={isOptionalBenefFields ? !disable : false}
          >
            <span id="WA_MEMBER_SEARCH" />
          </Button>
        </Col>}
      </Row>
    );
  };

  const checkIfDobDisabled = (current: Date): boolean => {
    return isBefore(startOfDay(current), todayDate);
  };

  const getSearchUI = (): ReactElement | null => {
    if (isGovtScheme) {
      return (
        <Row gutter={GUTTOR_SPACE} className="search-align-items">
          <Col flex="auto" className="beneficiary-search-using">
            <FormTextInput detail={{
              ...commonDetails,
              key: 'employeeId',
              isLoading,
              disabled: loading,
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('employeeId'),
              onBlur: (e: any): any => handleUserUnFocus('employeeId', e),
              floatLabel: inputStates?.employeeId?.isFocused || inputStates?.employeeId?.hasValue,
              hideLabel: true,
              ...(inputStates?.employeeId?.isFocused ? { placeholder: '' } : {}),
              fieldInFocus: inputStates?.employeeId?.isFocused,
              required: true,
            }}
            />
          </Col>
        </Row>
      );
    } else if ((selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[0] || selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_MDI[0] ||
      selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_SHAI[0])) {
      return (
        <Row gutter={GUTTOR_SPACE} className="search-align-items">
          <Col md={(showStarBenefFields) ? 16 : 8}
            className={`beneficiary-search-using`}>
            <FormTextInput detail={{
              ...commonDetails,
              key: 'memberId',
              isLoading,
              onChange: memberIDvalidation,
              rules: (shortName === 'ABHI' && !memberIdCheck) ? [abhiValidation] : [],
              className: `HISSearchUI ${isOptionalBenefFields ? 'benef-mdid-prefix' : ''}`,
              onFocus: (): any => handleUserFocus('memberId'),
              onBlur: (e: any): any => handleUserUnFocus('memberId', e),
              floatLabel: inputStates?.memberId?.isFocused || inputStates?.memberId?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.memberId?.isFocused ? '' : isOptionalBenefFields ?
                BENEF_CONSTANTS.MDI_PLACEHOLDER : showStarBenefFields ?
                  BENEF_CONSTANTS?.CUSTOMER_ID_PLACEHOLDER : BENEF_CONSTANTS?.MEMBER_ID_PLACEHOLDER,
              fieldInFocus: inputStates?.memberId?.isFocused,
              required: true,
              disabled: loading,
              ...(isOptionalBenefFields ? {
                label: BENEF_CONSTANTS.MDID,
                regex: ONLY_NUMBER_REGEX,
                ignorePrefixInput: true,
                addonBefore: (inputStates?.memberId?.isFocused || inputStates?.memberId?.hasValue) && MDI_MEMBERID_PREFIX,
              } : undefined),
            }} />
          </Col>
          {(!showStarBenefFields) && <Col flex="1">
            {isOnlyMemberIdBenefField ?
              <FormTextInput detail={{
                ...commonDetails,
                key: 'policyNumber',
                onChange: getPolicyGrouping,
                rules: [
                  ...(isPolicyGroupEnabled ? [policyValidation] : [otherPolicyValidation]),
                ],
                isLoading,
                isName: false,
                className: 'HISSearchUI',
                onFocus: (): any => handleUserFocus('policyNumber'),
                onBlur: (e: any): any => handleUserUnFocus('policyNumber', e),
                floatLabel: inputStates?.policyNumber?.isFocused || inputStates?.policyNumber?.hasValue,
                hideLabel: true,
                placeholder: inputStates?.policyNumber?.isFocused ? '' : showStarBenefFields ?
                  BENEF_CONSTANTS?.POLICY_NO_RETAIL_PLACEHOLDER : BENEF_CONSTANTS?.POLICY_NO_PLACEHOLDER,
                searchType: 'search-option-1',
                fieldInFocus: inputStates?.policyNumber?.isFocused,
                required: true,
                disabled: loading,
              }} /> :
              <FormTextInput className="benef-search-patient-name"
                detail={{
                  ...commonDetails,
                  key: 'patientName',
                  label: 'Patient Name',
                  isLoading,
                  isName: true,
                  smallFloatLabel: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                  rules: [
                    { max: 50, message: PATIENT_NAME_MAX_CHAR_LIMIT },
                    ...(inMinCharacterValidationRequired ? [{ min: 4, message: PATIENT_NAME_MIN_CHAR_LIMIT }] : [])],
                  isMaxLengthNotApplicable: true,
                  className: 'HISSearchUI',
                  onFocus: (): any => handleUserFocus('patientName'),
                  onBlur: (e: any): any => handleUserUnFocus('patientName', e),
                  floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName?.hasValue,
                  hideLabel: true,
                  placeholder: inputStates?.patientName?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
                  smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                  fieldInFocus: inputStates?.patientName?.isFocused,
                  required: true,
                  disabled: loading,
                }} />
            }
          </Col>
          }
          {memberIdCheck && (
            <Col>
              <Text type="secondary" className="ml-0 custom-group" style={{ color: '#3c3ada' }}>
                Bajaj Finance Numbers are not allowed, please enter proper member ID or Do a Policy Search.
              </Text>
            </Col>
          )}
        </Row>
      );
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[1] || selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_MDI[1] ||
      selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_SHAI[1]) {
      return (
        <Row gutter={GUTTOR_SPACE} className="search-align-items">
          <Col md={showStarBenefFields ? 12 : isPolicyNoReqForEmpId ? 10 : dateOfBirthRequired ? 14 : 7}
            className={`beneficiary-search-using ${dateOfBirthRequired ? '' : 'rbr-0'}`}>
            <FormTextInput detail={{
              ...commonDetails,
              key: 'employeeId',
              isLoading,
              regex: (shortName === 'HDFC') ? null : EMPLOYEE_ID_REGEX,
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('employeeId'),
              onBlur: (e: any): any => handleUserUnFocus('employeeId', e),
              floatLabel: inputStates?.employeeId?.isFocused || inputStates?.employeeId?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.employeeId?.isFocused ? '' : isOptionalBenefFields ? BENEF_CONSTANTS.EMPLOYEE_ID_PLACEHOLDER_MDI :
                BENEF_CONSTANTS.EMPLOYEE_ID_PLACEHOLDER,
              fieldInFocus: inputStates?.employeeId?.isFocused,
              required: true,
              disabled: loading,
            }} />
          </Col>
          {isPolicyNoReqForEmpId ? (
            <>
              <Col md={showStarBenefFields ? 12 : 5} className={`beneficiary-search-using ml-14 ${showStarBenefFields ? 'star-search-field' : ''}`}>
                <FormTextInput detail={{
                  ...commonDetails,
                  key: 'policyNumber',
                  onChange: getPolicyGrouping,
                  rules: [
                    ...(isPolicyGroupEnabled ? [policyValidation] : [otherPolicyValidation]),
                  ],
                  isLoading,
                  isName: false,
                  className: 'HISSearchUI',
                  onFocus: (): any => handleUserFocus('policyNumber'),
                  onBlur: (e: any): any => handleUserUnFocus('policyNumber', e),
                  floatLabel: inputStates?.policyNumber?.isFocused || inputStates?.policyNumber?.hasValue,
                  hideLabel: true,
                  placeholder: inputStates?.policyNumber?.isFocused ? '' : showStarBenefFields ?
                    BENEF_CONSTANTS?.POLICY_NO_RETAIL_PLACEHOLDER : BENEF_CONSTANTS?.POLICY_NO_PLACEHOLDER,
                  searchType: 'search-option-1',
                  fieldInFocus: inputStates?.policyNumber?.isFocused,
                  required: true,
                  disabled: loading,
                }} />
              </Col>
            </>
          ) : dateOfBirthRequired ? (
            <Col flex="1" className="benef-search-patient-nam">
              <FormInputDate
                detail={{
                  ...commonDetails,
                  key: 'dateOfBirth',
                  className: 'HISSearchUI',
                  customIcon: !inputStates?.dateOfBirth?.hasValue,
                  fieldInFocus: inputStates?.dateOfBirth?.isFocused,
                  onFocus: (): any => handleUserFocus('dateOfBirth'),
                  onBlur: (e: any): any => handleUserUnFocus('dateOfBirth', e),
                  hideLabel: true,
                  placeholder: inputStates?.dateOfBirth?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
                  disabledDate: (current: any): boolean => checkIfDobDisabled(current),
                  hidden: false,
                }}
              />
            </Col>
          ) : (
            <Col md={7} className="beneficiary-search-using ml-14">
              {shortName === 'RGI' || isOptionalBenefFields ? (
                <FormTextInput detail={{
                  ...commonDetails,
                  key: 'policyNumber',
                  onChange: getPolicyGrouping,
                  rules: [
                    ...(isPolicyGroupEnabled ? [policyValidation] : [otherPolicyValidation]),
                  ],
                  isLoading,
                  isName: false,
                  className: 'HISSearchUI',
                  onFocus: (): any => handleUserFocus('policyNumber'),
                  onBlur: (e: any): any => handleUserUnFocus('policyNumber', e),
                  floatLabel: inputStates?.policyNumber?.isFocused || inputStates?.policyNumber?.hasValue,
                  hideLabel: true,
                  placeholder: inputStates?.policyNumber?.isFocused ? '' : BENEF_CONSTANTS.POLICY_NUMBER_PLACEHOLDER,
                  searchType: 'search-option-1',
                  fieldInFocus: inputStates?.policyNumber?.isFocused,
                  required: true,
                  disabled: loading,
                }} />
              ) : (
                <FormTextInput detail={{
                  ...commonDetails,
                  key: 'corporateName',
                  isLoading,
                  regex: CORPRATE_NAME_REGEX,
                  className: 'HISSearchUI',
                  onFocus: (): any => handleUserFocus('corporateName'),
                  onBlur: (e: any): any => handleUserUnFocus('corporateName', e),
                  floatLabel: inputStates?.corporateName?.isFocused || inputStates?.corporateName?.hasValue,
                  hideLabel: true,
                  placeholder: inputStates?.corporateName?.isFocused ? '' : 'Enter Corporate Name',
                  searchType: 'search-option-1',
                  fieldInFocus: inputStates?.corporateName?.isFocused,
                  required: true,
                  disabled: loading,
                }} />
              )}
            </Col>
          )}

          {!showStarBenefFields && !dateOfBirthRequired && <Col flex="1" className="benef-search-patient-name">
            <FormTextInput detail={{
              ...commonDetails,
              key: 'patientName',
              label: 'Patient Name',
              isLoading,
              isName: true,
              smallFloatLabel: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
              rules: [
                { max: 50, message: PATIENT_NAME_MAX_CHAR_LIMIT },
                ...(inMinCharacterValidationRequired ?  [{min : 4  , message : PATIENT_NAME_MIN_CHAR_LIMIT}] : [])],
              isMaxLengthNotApplicable: true,
              className: 'HISSearchUI',
              onFocus: (): any => handleUserFocus('patientName'),
              onBlur: (e: any): any => handleUserUnFocus('patientName', e),
              floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName?.hasValue,
              hideLabel: true,
              placeholder: inputStates?.patientName?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
              smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
              searchType: 'patient-name-float',
              fieldInFocus: inputStates?.patientName?.isFocused,
              disabled: loading,
              required: true,
            }} />
          </Col>
          }
        </Row>
      );
    } else if (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[2] || selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_SHAI[2]) {
      return (
        <Row gutter={GUTTOR_SPACE} className="search-align-items">
          {isOptionalBenefFields && (
            <Col md={12}>
              <FormSelect
                detail={{
                  ...commonDetails,
                  key: 'policyType',
                  showSearch: true,
                  options: POLICY_TYPE_OPTIONS.SECTOR_TYPES,
                  onChange: onChangePolicyType,
                  label: BENEF_CONSTANTS.POLICY_TYPE_LABEL,
                  className: 'his-select Re-Design-RPA-field-Dropdown',
                  suffixIcon: <DownArrow />,
                  isRedesign: true,
                  hideLabel: true,
                  required: true,
                  hidden: false,
                  disabled: loading,
                  onFocus: (): any => handleUserFocus('policyType'),
                  onBlur: (e: any): any => handleUserUnFocus('policyType', e),
                  fieldInFocus: inputStates?.policyType?.isFocused,
                }}
              />
            </Col>
          )}
          {!isOptionalBenefFields && (
            <>
              <Col
                md={showStarBenefFields ? 11 : isEmployeeIdOptional ? 7 : 9}
                className={`beneficiary-search-using ${isEmployeeIdOptional && !showStarBenefFields ? 'rbr-0' : ''
                  }`}
              >
                <FormTextInput
                  detail={{
                    ...commonDetails,
                    key: 'policyNumber',
                    onChange: getPolicyGrouping,
                    onInput: (e: any): any => policyNoSpaceCheck(e),
                    rules: [
                      ...(isPolicyGroupEnabled ? [policyValidation] : [otherPolicyValidation]),
                    ],
                    isLoading,
                    isName: false,
                    className: 'HISSearchUI',
                    onFocus: (): any => handleUserFocus('policyNumber'),
                    onBlur: (e: any): any => handleUserUnFocus('policyNumber', e),
                    floatLabel: inputStates?.policyNumber?.isFocused || inputStates?.policyNumber?.hasValue,
                    hideLabel: true,
                    placeholder: inputStates?.policyNumber?.isFocused ? '' : showStarBenefFields ?
                      BENEF_CONSTANTS?.POLICY_NO_RETAIL_PLACEHOLDER : BENEF_CONSTANTS?.POLICY_NO_PLACEHOLDER,
                    fieldInFocus: inputStates?.policyNumber?.isFocused,
                    searchType: 'patient-name-float',
                    required: true,
                    disabled: loading,
                  }}
                />
              </Col>

              <Col flex="1" className="benef-search-patient-name">
                <FormTextInput detail={{
                  ...commonDetails,
                  key: 'patientName',
                  label: 'Patient Name',
                  isLoading,
                  isName: true,
                  smallFloatLabel: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                  rules: [
                    { max: 50, message: PATIENT_NAME_MAX_CHAR_LIMIT },
                    ...(inMinCharacterValidationRequired ? [{ min: 4, message: PATIENT_NAME_MIN_CHAR_LIMIT }] : [])],
                  isMaxLengthNotApplicable: true,
                  className: 'HISSearchUI',
                  onFocus: (): any => handleUserFocus('patientName'),
                  onBlur: (e: any): any => handleUserUnFocus('patientName', e),
                  floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName?.hasValue,
                  hideLabel: true,
                  placeholder: inputStates?.patientName?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
                  smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                  fieldInFocus: inputStates?.patientName?.isFocused,
                  disabled: loading,
                  required: !isOptionalBenefFields,
                }} />
              </Col>
            </>
          )}
        </Row>

      );
    } else {
      return null;
    }
  };

  return (
    <>
      <Form
        layout="vertical"
        form={benefForm}
        validateMessages={VALIDATE_MESSAGES}
        onFinish={onClickSearch}
        requiredMark="optional"
        noValidate={true}
        onValuesChange={resetBenefSearch}
      >
        <Row gutter={GUTTOR_SPACE} className="his-search-row-cont">
          <Col md={(isGovtScheme) ? 6 : showStarBenefFields ? 7 : 4} className="beneficiary-dropdown">
            <FormSelect
              detail={{
                ...commonDetails,
                allowClear: false,
                key: 'iHave',
                options: benefSearchFields ? benefSearchFields : [],
                onChange: onSearchChange,
                required: true,
                className: 'his-select unrounded-right',
                isRedesign: true,
                suffixIcon: <DownArrow />,
                disabled: loading,
              }}
            />
          </Col>
          <Col md={
            isGovtScheme ? 16 : (showStarBenefFields && selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[1]) ? 17 :
              showStarBenefFields ? 15 : 18}
            className="beneficiary-search-options">
            {getSearchUI()}
          </Col>
          {!((isOptionalBenefFields && selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[2]) ||
            (selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_SHAI[0] ||
              selectedBenefSearch === BENEFICIARY_SEARCH_OPTION_SHAI[1] && showStarBenefFields)) && (
              <Col md={2} className="his-beneficiary-search-button">
                <Button
                  data-testid="beneficiary-search-button"
                  type={!disable ? undefined : 'primary'}
                  style={{ width: 120, height: 36 }}
                  htmlType="submit"
                  loading={loading}
                  className={`NA-his-next-button benef-submit-btn`}
                  icon={<SearchIcon className="his-benef-search-icon" />}
                >
                  <span id="WA_MEMBER_SEARCH" />
                </Button>
              </Col>
            )}
        </Row>
        {renderStarBenefFields()}
        {selectedBenefSearch === BENEFICIARY_SEARCH_OPTION[2] && isOptionalBenefFields && !isEmpty(policyTypeValue) && (
          <Row gutter={GUTTOR_SPACE} className="search-align-items mt-sm">

            <FormTextInput
              detail={{
                ...commonDetails,
                key: 'policyNumber',
                onChange: getPolicyGrouping,
                onInput: (e: any): any => policyNoSpaceCheck(e),
                size: (policyTypeValue === POLICY_TYPE_OPTIONS.SECTOR_TYPES[0] ? 12 : 7),
                rules: [
                  ...(isPolicyGroupEnabled ? [policyValidation] : [otherPolicyValidation]),
                ],
                isLoading,
                isName: false,
                className: 'HISSearchUI',
                onFocus: (): any => handleUserFocus('policyNumber'),
                onBlur: (e: any): any => handleUserUnFocus('policyNumber', e),
                floatLabel: inputStates?.policyNumber?.isFocused || inputStates?.policyNumber?.hasValue,
                hideLabel: true,
                placeholder: inputStates?.policyNumber?.isFocused ? '' : BENEF_CONSTANTS.POLICY_NUMBER_PLACEHOLDER,
                fieldInFocus: inputStates?.policyNumber?.isFocused,
                required: true,
                disabled: loading,
              }} />
              <FormTextInput
                detail={{
                  ...commonDetails,
                  key: 'patientName',
                  isLoading,
                  size: (policyTypeValue === POLICY_TYPE_OPTIONS.SECTOR_TYPES[0] ? 10 : 7),
                  isName: true,
                  smallFloatLabel: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                  rules: [
                  { max: 50, message: PATIENT_NAME_MAX_CHAR_LIMIT },
                  ...(inMinCharacterValidationRequired ? [{ min: 4, message: PATIENT_NAME_MIN_CHAR_LIMIT }] : [])],
                  isMaxLengthNotApplicable: true,
                  className: 'HISSearchUI',
                  onFocus: (): any => handleUserFocus('patientName'),
                  onBlur: (e: any): any => handleUserUnFocus('patientName', e),
                  floatLabel: inputStates?.patientName?.isFocused || inputStates?.patientName?.hasValue,
                  hideLabel: true,
                  placeholder: inputStates?.patientName?.isFocused ? '' : BENEF_CONSTANTS.PATIENT_NAME_PLACEHOLDER,
                  smallPlaceholder: BENEF_CONSTANTS.PATIENT_NAME_SMALL_PLACEHOLDER,
                  searchType: 'search-option-3',
                  fieldInFocus: inputStates?.patientName?.isFocused,
                  disabled: loading,
                  required: true,
                }} />
            {policyTypeValue === POLICY_TYPE_OPTIONS.SECTOR_TYPES[1] &&
              <FormTextInput
                detail={{
                  ...commonDetails,
                  key: 'employeeId',
                  isLoading,
                  size: 7,
                  regex: EMPLOYEE_ID_REGEX,
                  className: 'HISSearchUI',
                  onFocus: (): any => handleUserFocus('employeeId'),
                  onBlur: (e: any): any => handleUserUnFocus('employeeId', e),
                  floatLabel: inputStates?.employeeId?.isFocused || inputStates?.employeeId?.hasValue,
                  hideLabel: true,
                  placeholder: inputStates?.employeeId?.isFocused ? '' : isOptionalBenefFields ?
                    BENEF_CONSTANTS.EMPLOYEE_ID_PLACEHOLDER_MDI :
                    BENEF_CONSTANTS.EMPLOYEE_ID_PLACEHOLDER,
                  fieldInFocus: inputStates?.employeeId?.isFocused,
                  disabled: loading,
                  required: true,
                }} />
            }
            <Col md={2} className="ICICI-Search">
              <Button
                data-testid="beneficiary-search-button"
                type={!disable ? undefined : 'primary'}
                style={{ width: 120, height: 36 }}
                htmlType="submit"
                loading={loading}
                className={'NA-his-next-button NA-top-2benef-submit-btn'}
                disabled={false}
                icon={<SearchIcon className="his-benef-search-icon" />}
              >
                <span id="WA_MEMBER_SEARCH" />
              </Button>
            </Col>
          </Row>
        )}
      </Form>
      {
        <Row className="policy_number_warning">
          <Col>
            {!policyWarn && !policyCheck && (
              <Text type="secondary" className="ml-0 custom-group policy_warning_color">
                Please verify the policy number format before submitting.
              </Text>
            )}
          </Col>
          <Col className="policy_warning_policy_type">
            {currentGrp && isPolicyGroupEnabled && !policyCheck && (
              <Text type="secondary" className="ml-0 custom-group">
                Policy type: <strong>{currentGrp}</strong>
              </Text>
            )}
          </Col>
        </Row>
      }

      {showRetryMessage && (!ClaimCreationWithoutBenef && !loading) ?
        (<Row className="benef-text-member-id m-md">
          {displayMessage}
        </Row>
        )
        : null}
      {hyphenatedBasedGroupPolicy && combiPolicyExist &&
        (<div className="m-md-1">
          <Row className="benef-text-member-id">
            <p>
              <b>{GROUP_POLICY_HDFC}</b>
            </p>
          </Row>
        </div>
        )}
    </>
  );
};

export default BeneficiarySearchPanelRedesign;
